import {
  QUERY_CONFIGS,
  QueryConfigKeys,
} from '@hub/utils/react-query/query-config';
import { fetchPaymentProviders } from '@hub/utils/react-query/query-functions';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';
import { ExtractFnReturnType } from '@hub/utils/react-query/react-query';
import { useQuery } from '@tanstack/react-query';

const CONFIG_KEY = QueryConfigKeys.PAYMENT_PROVIDERS;

export const usePaymentProviders = (currency: string) => {
  return useQuery<ExtractFnReturnType<typeof fetchPaymentProviders>>({
    queryKey: QUERY_KEYS[CONFIG_KEY].LIST(currency),
    queryFn: () => fetchPaymentProviders(currency),
    staleTime: QUERY_CONFIGS[CONFIG_KEY]?.staleTime,
    enabled: !!currency,
  });
};
